'use strict';
const angular = require('angular');

export class documentsWidgetComponent {

  constructor(DocumentService) {
    'ngInject';

    this.DocumentService = DocumentService;
  }

  $onInit() {
    this.DocumentService.getNewest({count: this.count || 3}, data => {
      this.data = data;
    }, err => {
      console.log('could not retrieve newest documents');
    });
  }
}

export default angular.module('conduuApp.nifty.documentsWidget', [])
  .component('niftyDocumentsWidget', {
    template: require('./documents-widget.component.html'),
    bindings: {
      count: '@'
    },
    controller: documentsWidgetComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/nifty/documents-widget/documents-widget.component.js